module.exports = __webpack_public_path__ + "img/sentosa-wave-white.6380c30d.svg";